// This file is auto-generated. Do not edit manually.
import { FieldName, mutations } from "./updateList";

export const groupedUpdateList: Record<FieldName, mutations> = {
  applications: ["createApplications", "deleteApplications"],
  authClients: ["createAuthClients", "deleteAuthClients"],
  federatedClients: ["createFederatedClients", "deleteFederatedClients"],
  groups: ["createGroups", "deleteGroups"],
  organizations: ["createOrganizations", "deleteOrganizations"],
  profiles: ["createProfiles", "deleteProfiles", "mergeProfiles"],
  profileShares: ["createProfileShares", "deleteProfileShares"],
  properties: ["createProperties", "deleteProperties"],
  users: ["createUsers", "deleteUsers"],
};
